<template>
  <div
    :class="'section ' + (lastSection === true ? 'fp-auto-height ' : isMobileOrTabletOrApp || fullpageBehaviourDisabled ? 'fp-auto-height-responsive' : '')">

    <v-container :style="'width: 100%; max-width: 100% !important; min-width: 100%; ' + containerStyle"
                 class="pa-0 ma-0"
                 fluid>
      <v-container class="pa-0 ma-0 containerContent"
                   style="width: 100%;max-width: 100% !important; min-width: 100%; ">
        <v-row class="align-self-end" no-gutters style="z-index: 1">
          <v-col>
            <slot/>
          </v-col>
        </v-row>
      </v-container>
    </v-container>

  </div>
</template>

<script>
import finBrowser from "@/js/finBrowser"

export default {
  name: 'FinFullPageSection',
  props: {
    /* Do not use it to set a footer background. Use last-section option instead. */
    containerStyle: {
      type: String
    },
    fullpageBehaviourDisabled: {
      type: Boolean,
      default: false
    },
    lastSection: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isMobileOrTabletOrApp: finBrowser.IS_MOBILE_OR_TABLET || finBrowser.IS_IOS_OR_ANDROID_APP,
    }
  },
}
</script>

<style scoped lang="scss">

</style>
